export default "__VITE_ASSET__aad96e25__"